/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */

/** @jsx jsx */

import { jsx } from '@emotion/react'
import React, { type FunctionComponent } from 'react'

import { EuiFlexGroup, EuiSpacer, EuiText, EuiTitle } from '@elastic/eui'

import { DocLink } from '@modules/doclinks'
import { FormattedMessage } from '@modules/i18n'

export type Props = {
  title: React.ReactNode
}

const Header: FunctionComponent<Props> = ({ title }) => (
  <EuiFlexGroup direction='column' gutterSize='none'>
    <EuiTitle size='l'>
      <h2>{title}</h2>
    </EuiTitle>
    <EuiSpacer size='m' />
    <EuiText size='s' color='subdued'>
      <FormattedMessage
        id='billing.notifications.budgets.budget-settings.description'
        defaultMessage='Set a spending threshold for your organization to track usage and avoid surprises on your bill. {learnMore}'
        values={{
          learnMore: (
            <DocLink
              data-test-subj='billing.notifications.budgets.budget-settings.description.learn-more'
              link='billingCreateBudgetEmails'
              showExternalLinkIcon={true}
            >
              <FormattedMessage
                id='billing.notifications.budgets.budget-settings.description.learn-more'
                defaultMessage='Learn more'
              />
            </DocLink>
          ),
        }}
      />
    </EuiText>
  </EuiFlexGroup>
)

export default Header
